// extracted by mini-css-extract-plugin
export default {"section":"JoinWithUs_section__kvyp5","wrapper":"JoinWithUs_wrapper__z9PcU"};